import { Box } from "@mui/material";

export const ChesslaBrand = () => (
  <Box
    component="img"
    src="/chessla-wordmark.png"
    alt="CHESSLA"
    width={3048}
    height={520}
    data-testid="chessla-wordmark"
    sx={{
      color: "inherit",
      display: "block",
      width: 143,
      height: "auto",
      flexShrink: 0,
      "a.MuiListItemButton-root.active &": { filter: "invert(1)" },
    }}
  />
);
